import { createUiIdContext } from '../../contexts/ElementIdContext';

const elementIDs = {
  btnViewLinked: 'btnViewLinked',
  divOutletList: 'divOutletList',
  divOutletForm: 'divOutletForm',
};

export const { ElementIdProvider, useElementIdContext } =
  createUiIdContext(elementIDs);
